module.exports = __webpack_public_path__ + "static/logo-a71e8cf9e1996f45c0fdfe36701bdae2.jpg";